/**
 * Click&Clean
 *
 * Privacy cleaner; static resources scoped to its own vendor site.
 *
 * Behavioural discovery (tooling/batch-interactions.js) found no usable page-side
 * marker for this extension, so detection falls back to resource probing.
 * Manifest verified against version 9.8.2.0.
 */
import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'ghgabhipcejejjmhhchfonmamedcbeod';
export const clickAndClean: ExtensionDefinition = {
  id: ID,
  name: "Click&Clean",
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 1000000,
  requiredOrigin: 'https://www.hotcleaner.com',
  notes: "Privacy cleaner; static resources scoped to its own vendor site.",
  signals: [
    { id: 'war-ehistory901-html', kind: 'web-accessible-resource',
      description: 'Fetch ehistory901.html, exposed only to https://www.hotcleaner.com.',
      weight: 1, run: () => probeFetch(ID, 'ehistory901.html') },
    { id: 'war-ecache901-html', kind: 'web-accessible-resource',
      description: 'Fetch ecache901.html, exposed only to https://www.hotcleaner.com.',
      weight: 0.5, run: () => probeFetch(ID, 'ecache901.html') },
  ],
};
